import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../axios/api'

export const fetchCounts = createAsyncThunk(
  'counts/fetchCounts',
  async ({ companyId, yearId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/company/counts?company_id=${companyId}&year_id=${yearId}`);
      return response.data.data[0];
    } catch (error) {
      return rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);

const countsSlice = createSlice({
  name: 'counts',
  initialState: {
    data: {},
    loading: false,
    error: null
  },
  reducers: {
    clearCounts: (state) => {
      state.data = {};
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCounts.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchCounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearCounts } = countsSlice.actions;

// Selectors
export const selectCounts = (state) => state.counts.data;
export const selectCountsLoading = (state) => state.counts.loading;
export const selectCountsError = (state) => state.counts.error;

export default countsSlice.reducer;
